(function() {
  function initVinylSearch() {
    var form = document.getElementById('VinylCollectionSearch');
    var input = document.getElementById('VinylSearchInput');
    var results = document.getElementById('VinylSearchResults');

    if (!form || !input || !results) return;

    var productsCache = null;
    var loading = null;

    function normalize(text) {
      return (text || '')
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    function loadProducts() {
      if (productsCache) {
        return Promise.resolve(productsCache);
      }

      if (loading) {
        return loading;
      }

      loading = Promise.all([
        fetch('/collections/vinilos/products.json?limit=250&page=1').then(function(r) {
          return r.json();
        }),
        fetch('/collections/vinilos/products.json?limit=250&page=2').then(function(r) {
          return r.json();
        }),
        fetch('/collections/vinilos/products.json?limit=250&page=3').then(function(r) {
          return r.json();
        }),
        fetch('/collections/vinilos/products.json?limit=250&page=4').then(function(r) {
          return r.json();
        }),
        fetch('/collections/vinilos/products.json?limit=250&page=5').then(function(r) {
          return r.json();
        }),
        fetch('/collections/vinilos/products.json?limit=250&page=6').then(function(r) {
          return r.json();
        }),
        fetch('/collections/vinilos/products.json?limit=250&page=7').then(function(r) {
          return r.json();
        })
      ]).then(function(pages) {
        productsCache = [];

        pages.forEach(function(page) {
          if (page.products) {
            productsCache = productsCache.concat(page.products);
          }
        });

        return productsCache;
      }).catch(function(error) {
        console.error('Error cargando vinilos:', error);
        return [];
      });

      return loading;
    }

    function showResults(products, query) {
      var search = normalize(query);

      var matches = products.filter(function(product) {
        return normalize(product.title).indexOf(search) !== -1;
      });

      if (!matches.length) {
        results.innerHTML = '<p>No se han encontrado discos.</p>';
        return;
      }

      results.innerHTML = matches.map(function(product) {
        var image = '';

        if (product.images && product.images.length) {
          image = product.images[0].src || '';
        }

        var title = product.title || '';
        var price = '';

        if (product.variants && product.variants.length) {
          price = product.variants[0].price || '';
        }

        return '<a class="vinyl-search-result" href="/products/' + product.handle + '">' +
          '<div class="vinyl-search-result-image">' +
            (image ? '<img src="' + image + '" alt="' + title.replace(/"/g, '&quot;') + '">' : '') +
          '</div>' +
          '<div class="vinyl-search-result-info">' +
            '<div class="vinyl-search-result-title">' + title + '</div>' +
            '<div class="vinyl-search-result-price">' + price + ' €</div>' +
          '</div>' +
        '</a>';
      }).join('');
    }

    form.addEventListener('submit', function(event) {
      event.preventDefault();

      var query = input.value.trim();

      if (!query) {
        results.innerHTML = '';
        return;
      }

      results.innerHTML = '<p>Buscando...</p>';

      loadProducts().then(function(products) {
        showResults(products, query);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVinylSearch);
  } else {
    initVinylSearch();
  }
})();